import type { IconNode } from '../types';

/**
 * @name flower-lotus
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjBjMC01LjUtNC41LTEwLTEwLTEwIDAgNS41IDQuNSAxMCAxMCAxMCIgLz4KICA8cGF0aCBkPSJNOS43IDguM2MtMS44LTItMy44LTMuMS0zLjgtMy4xcy0uOCAyLjUtLjUgNS40IiAvPgogIDxwYXRoIGQ9Ik0xNSAxMi45VjEyYzAtNC40LTMtOC0zLThzLTMgMy42LTMgOHYuOSIgLz4KICA8cGF0aCBkPSJNMTguNiAxMC42Yy4zLTIuOS0uNS01LjQtLjUtNS40cy0yIDEtMy44IDMuMSIgLz4KICA8cGF0aCBkPSJNMTIgMjBjNS41IDAgMTAtNC41IDEwLTEwLTUuNSAwLTEwIDQuNS0xMCAxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/flower-lotus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const flowerLotus: IconNode = [
  ['path', { d: 'M12 20c0-5.5-4.5-10-10-10 0 5.5 4.5 10 10 10', key: 'ljwpiw' }],
  ['path', { d: 'M9.7 8.3c-1.8-2-3.8-3.1-3.8-3.1s-.8 2.5-.5 5.4', key: '1mtfva' }],
  ['path', { d: 'M15 12.9V12c0-4.4-3-8-3-8s-3 3.6-3 8v.9', key: '1s2qdn' }],
  ['path', { d: 'M18.6 10.6c.3-2.9-.5-5.4-.5-5.4s-2 1-3.8 3.1', key: 'od7r68' }],
  ['path', { d: 'M12 20c5.5 0 10-4.5 10-10-5.5 0-10 4.5-10 10', key: '5gyawo' }],
];

export default flowerLotus;
